import type { FC } from 'react';
import type { SettingsRecipeT } from './component';
import {
  RateRecipeBtn,
  RecipeAuthor,
  RecipeDescription,
  RecipeImageMobile,
  RecipeIsPromo,
  RecipeMobileTabs,
  RecipePFC,
  RecipeStats,
  RecipeTip
} from './components/components';
import RecipeAddAllToCart from './components/RecipeAddAllToCart';
// import PdfRecipe from './components/PdfRecipe';

const RecipeMobile: FC<SettingsRecipeT> = ({
  toggleLeaveRecipeFeedbackModal,
  scrollToCommentsBlock,
  recipe,
  handleRecipeFavorites,
  isFavorite,
  isWithoutPhotos
}) => {
  if (!recipe) {
    return null;
  }
  return (
    <div className='allMd:mb-0 mb-14'>
      <div className=''>
        <RecipeImageMobile
          title={recipe.title}
          rubric={recipe.bludoItem?.title}
          isFavorite={isFavorite}
          handleRecipeFavorites={handleRecipeFavorites}
          mainImage={recipe?.attachmentsItem?.cacheItem?.[0]?.filePath}
          comments={recipe.comments_number}
          viewCount={recipe.viewCount}
          rating={recipe.rating}
          date={recipe.date}
          scrollToCommentsBlock={scrollToCommentsBlock}
          video_code={recipe.video_code}
        />
      </div>
      <div className='mb-3'>
        {!!recipe.is_product_promo && <RecipeIsPromo />}
      </div>
      <div className=''>
        <RecipeStats
          calories={recipe.calories}
          difficulty={recipe.recipes_difficult}
          serving={recipe.serving}
          time={recipe.cooking_time}
        />
        <RecipePFC
          carbohydrates={recipe.carbohydrates}
          fat={recipe.fat}
          protein={recipe.protein}
          calories={recipe.calories}
        />
        <RecipeDescription text={recipe.text} />

        <RecipeAuthor
          fio={recipe.authorItem?.fio}
          identify={recipe.authorItem?.identify}
          title={recipe.authorItem?.title}
          avatar={
            recipe.authorItem?.userItem?.attachmentsItem?.tempFullFilePath
          }
        />
        {recipe.tip && (
          <RecipeTip tip={recipe.tip} isGrey={!!recipe.video_code} />
        )}
      </div>
      <RecipeMobileTabs
        video_code={recipe.video_code}
        isWithoutPhotos={isWithoutPhotos}
        recipeInstructions={recipe.recipeInstructions}
        recipeIngredients={recipe.recipeIngredients}
      />
      <div className='fixed bottom-0 left-0 z-[1000] w-full p-3 bg-white flex flex-col space-y-2.5'>
        <RecipeAddAllToCart
          catalogItemsIds={
            recipe.recipeIngredients
              ?.filter(
                item =>
                  item.ingredientsItems?.[0]?.catalogItem?.available &&
                  item?.ingredientsItems?.[0]?.catalogItem?.id
              )
              ?.map(
                item => item?.ingredientsItems?.[0]?.catalogItem?.id as string
              ) || []
          }
        />
        <RateRecipeBtn
          _votedRating={recipe._votedRating}
          toggleLeaveRecipeFeedbackModal={toggleLeaveRecipeFeedbackModal}
        />
      </div>
    </div>
  );
};

export default RecipeMobile;
